import { render } from "./Live.vue?vue&type=template&id=186764aa"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"
script.render = render

export default script